import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TOKEN_KEY = "vpp_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);
export const isAuthed = () => !!getToken();

const authHeaders = () => ({ Authorization: `Bearer ${getToken()}` });

export const formatError = (err) => {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return err?.message || "Something went wrong.";
};

// Auth
export const login = async (email, password) => {
  const { data } = await axios.post(`${API}/auth/login`, { email, password });
  setToken(data.token);
  return data.user;
};

export const verifySession = async () => {
  const { data } = await axios.get(`${API}/auth/me`, { headers: authHeaders() });
  return data;
};

// Associations
export const fetchAssociations = async () => {
  const { data } = await axios.get(`${API}/associations`);
  return data;
};

export const fetchAssociation = async (id) => {
  const { data } = await axios.get(`${API}/associations/${id}`);
  return data;
};

export const createAssociation = async (payload) => {
  const { data } = await axios.post(`${API}/associations`, payload, { headers: authHeaders() });
  return data;
};

export const updateAssociation = async (id, payload) => {
  const { data } = await axios.put(`${API}/associations/${id}`, payload, { headers: authHeaders() });
  return data;
};

export const deleteAssociation = async (id) => {
  const { data } = await axios.delete(`${API}/associations/${id}`, { headers: authHeaders() });
  return data;
};

// Enquiries
export const fetchEnquiries = async () => {
  const { data } = await axios.get(`${API}/enquiries`, { headers: authHeaders() });
  return data;
};
